import { AUTOMATIC_CARD_NOTIFICATIONS } from '../../../../../shared/i18n/toastsNotificationsTexts';
import { CARD_PROVIDERS, TEMPLATE_CARDS_PROVIDERS } from '../../../../../shared/constants/providers/AutomaticCardsProviders';
import { showToast } from '../../../../../shared/components/messages-and-errors/ToastsNotifications';
import { TOAST_TYPE } from '../../../../../shared/constants/NotificationsConstants';


const savingByProvider = {
    [CARD_PROVIDERS.ADS_IN_EXCESS]: 'adGroupYearlyProjection',
    [CARD_PROVIDERS.BAD_PLACEMENT_SITE_PERFORMACE]: 'annualSavings',
    [CARD_PROVIDERS.FACEBOOK_CREATIVE_EXPERIMENT]: 'improvement',
    [CARD_PROVIDERS.SEARCH_TERM_SUGGESTIONS]: 'annualSaving',
    [CARD_PROVIDERS.SMART_FUNNEL_CAMPAIGN]: 'campaign',
    [CARD_PROVIDERS.AD_EXPERIMENTS]: 'improvement',
    [CARD_PROVIDERS.DISPLAY_FRAUD_FINDER]: 'annualSavings',
    [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_AGE]: 'table',
    [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_DEVICE]: 'table',
    [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_GENDER]: 'table',
};

const getValueByProvider = (value, provider) => {
    switch (provider) {
    case CARD_PROVIDERS.ADS_IN_EXCESS:
        return value.performanceImprovement.toFixed(2);
    case CARD_PROVIDERS.SMART_FUNNEL_CAMPAIGN:
        return value.metricDiffPercentage;
    case TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_DEVICE:
    case TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_AGE:
    case TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_GENDER:
        return value[value.length - 1].value;
    default:
        return value.toFixed(2);
    }
};

const messageByProvider = (value, provider) => {
    const valueByProvider = value ? getValueByProvider(value, provider) : null;

    const texts = {
        [CARD_PROVIDERS.AD_CREATION]: AUTOMATIC_CARD_NOTIFICATIONS.AD_CREATION,
        [CARD_PROVIDERS.ADS_IN_EXCESS]: `${AUTOMATIC_CARD_NOTIFICATIONS.ADS_IN_EXCESS} ${valueByProvider}%`,
        [CARD_PROVIDERS.BAD_PLACEMENT_SITE_PERFORMACE]: `${AUTOMATIC_CARD_NOTIFICATIONS.BAD_PLACEMENT_SITE_PERFORMANCE_INITIAL} ${valueByProvider} ${
            AUTOMATIC_CARD_NOTIFICATIONS.BAD_PLACEMENT_SITE_PERFORMANCE_FINAL}`,
        [CARD_PROVIDERS.BRAND_DAMAGE_ALERT]: AUTOMATIC_CARD_NOTIFICATIONS.BRAND_DAMAGE_ALERT,
        [CARD_PROVIDERS.FACEBOOK_CREATIVE_EXPERIMENT]: `${AUTOMATIC_CARD_NOTIFICATIONS.FACEBOOK_CREATIVE_EXPERIMENT} ${valueByProvider}`,
        [CARD_PROVIDERS.SEARCH_TERM_SUGGESTIONS]: `${AUTOMATIC_CARD_NOTIFICATIONS.SEARCH_TERM_SUGGESTIONS} ${valueByProvider}`,
        [CARD_PROVIDERS.SMART_FUNNEL_CAMPAIGN]: `${AUTOMATIC_CARD_NOTIFICATIONS.SMART_FUNNEL_CAMPAIGN} ${valueByProvider}%!`,
        [CARD_PROVIDERS.ADS_WITH_OVER_90_DAYS]: AUTOMATIC_CARD_NOTIFICATIONS.ADS_WITH_OVER_DAYS,
        [CARD_PROVIDERS.ADS_WITH_OVER_180_DAYS]: AUTOMATIC_CARD_NOTIFICATIONS.ADS_WITH_OVER_DAYS,
        [CARD_PROVIDERS.ADS_WITH_OVER_1_YEAR]: AUTOMATIC_CARD_NOTIFICATIONS.ADS_WITH_OVER_DAYS,
        [CARD_PROVIDERS.AD_EXPERIMENTS]: `${AUTOMATIC_CARD_NOTIFICATIONS.AD_EXPERIMENTS} ${valueByProvider}%!`,
        [CARD_PROVIDERS.DISPLAY_FRAUD_FINDER]: `${AUTOMATIC_CARD_NOTIFICATIONS.DISPLAY_FRAUD_FINDER_INITIAL} ${valueByProvider} ${
            AUTOMATIC_CARD_NOTIFICATIONS.DISPLAY_FRAUD_FINDER_FINAL}`,
        [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_AGE]: `${AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_AGE_INITIAL} ${valueByProvider} ${
            AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_AGE_FINAL}`,
        [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_DEVICE]: `${AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_DEVICE_INITIAL} ${valueByProvider} ${
            AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_DEVICE_FINAL}`,
        [TEMPLATE_CARDS_PROVIDERS.TEMPLATE_BID_MODIFIER_GENDER]: `${AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_GENDER_INITIAL} ${valueByProvider} ${
            AUTOMATIC_CARD_NOTIFICATIONS.TEMPLATE_BID_MODIFIER_GENDER_FINAL}`,
    };

    return texts[provider] || AUTOMATIC_CARD_NOTIFICATIONS.DEFAULT_NOTIFICATION;
};

const automaticCardNotifications = (cardModalSelected) => {
    const { custom_data: customData, provider } = cardModalSelected;
    const field = savingByProvider[provider];
    const { [field]: value } = customData;

    const message = messageByProvider(value, provider);

    showToast(message, TOAST_TYPE.SUCCESS, {
        delay: 3100,
    });
};

export default automaticCardNotifications;
